export const REDESIGN_COLLAPSE_WIDTH = 110
export const COLLAPSE_WIDTH_VARIABLE = "--dashboard-collapse-width"
